import * as Yup from "yup";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { useEffect, useState } from "react";
import React from "react";
import { SelectField } from "../../core/select-field.component";
import { Upload, UploadOnAddEvent } from "@progress/kendo-react-upload";
import CardCustomerModel from "../../models/party/cardcustomer-model";
import { useGetDroppingPoint } from "../../apiclient/party/useGetDropingPointApi";
import { useGetCardCustomer } from "../../apiclient/party/useGetcardCustomerApi";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi";
import ImageUpload from "../../core/image-upload";

interface CardCustomerEditProps {
    data: CardCustomerModel;
    onClose?: (status: SubmitStatus, data: any) => any;
    isViewMode?: boolean;
}

const CardCustomerEntry: React.FC<CardCustomerEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.cardCustomerId > 0 ? "Edit Card Customer" : "Add Card Customer";

    let initialValue: CardCustomerModel = {
        cardCustomerId: data?.cardCustomerId ? data.cardCustomerId : 0,
        customerCode: data?.customerCode,
        customerName: data?.customerName,
        address: data?.address,
        droppingPointId: data?.droppingPointId ? data.droppingPointId : 0,
        unionId: data?.unionId ? data.unionId : 0,
        customerPhoto: data?.customerPhoto,
        panNumber: data?.panNumber,
        mobileNumber: data?.mobileNumber,
        aadharNumber: data?.aadharNumber,
        rationcardNumber: data?.rationcardNumber,
    };
    console.log(initialValue)
    const validationSchema = Yup.object().shape({
       // customerCode: Yup.string().required("Required"),
       
       customerCode: Yup.string()
            .required("Required")
            .test("check-duplicate-customerCode", " Code already exists", (value) => {
                // Check if the employeeCode already exists in the list of existing codes
                return !existingcardcustomerCodes.includes(value) ||
          (data?.customerCode && value === data.customerCode)
            }),
            mobileNumber : Yup.string()
            .required("Required")
            .test("check-duplicate-mobileNumber", " MobileNumber already exists", (value) => {
                return !existingcardcustomerMobileNumbers.includes(value) ||
          (data?.mobileNumber && value === data.mobileNumber)
            }),
            customerName: Yup.string()
            .required("Required")
            .test("check-duplicate-name", "Card Customer Name already exists", (value) => {
              // Ensure the value is compared in a case-insensitive manner
              return (
                value &&
                !existingCustomerName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
                (data?.customerName && value === data.customerName) // Allow current name during update
              );
            }), 
            unionId: Yup.number()
            .required("Union is required")
            .test("unionId-not-zero", "Union must be selected", (value) => value !== 0),
    
        // rationcardNumber: Yup.string()
        //     .length(10, "Rationcard Number must be exactly 10 digits")  // Ensure exactly 10 digits
        //     .matches(/^[0-9]{10}$/, "Rationcard Number must be a valid 10-digit number")  // Ensure only digits
        //     .required("Required"),
        // panNumber: Yup.string()
        //     .length(10, "PAN number must be 10 characters")
        //     .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}/, "Invalid PAN Format")
        //     .required("Required"),
        // aadharNumber: Yup.string()
        //     .length(12, "Aadhar number must be 12 digits")
        //     .matches(/^[0-9]{12}$/, "Aadhar number must be a valid 12-digit number")
        //     .required("Required"),
    });
    const [image, setImage] = useState<File | null>(null);
    const [files, setFiles] = useState<any[]>([]);
    const onAdd = (event: UploadOnAddEvent) => {
        // Get the raw file object from the affected files
        const file = event.affectedFiles[0].getRawFile();
        setImage(file); // Set the file for preview or further processing
        setFiles(event.newState); // Update the list of files
    };

    const [existingcardcustomerCodes, setExistingCardCustomerCodes] = useState<string[]>([]);
    const [existingCustomerName, setExistingCustomerName] = useState<string[]>([]);

    const { data: fetchedcardCustomer } = useGetCardCustomer();
    const [existingcardcustomerMobileNumbers, setExistingCardCustomerMobileNumbers] = useState<string[]>([]);

    
    
    const [dropingpointData, setDropingPointData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedDropingPoint } = useGetDroppingPoint();

    const [unionData, setUnionData] = useState<{ value: string; label: string }[]>([]);
    const { data: fetchedDUnion } = useGetUnions();

    useEffect(() => {
        if (fetchedcardCustomer) {
            // Extract employee codes and PAN numbers from the fetched data
            setExistingCardCustomerCodes(fetchedcardCustomer.map((emp: any) => emp.customerCode));
            setExistingCardCustomerMobileNumbers(fetchedcardCustomer.map((emp: any) => emp.mobileNumber));
            setExistingCustomerName(fetchedcardCustomer.map((emp: any) => emp.customerName));

        }
        if (fetchedDropingPoint) {
            const mappeddropingpoint = fetchedDropingPoint.map((dropingpoint: any) => ({
                value: dropingpoint.droppingpointId,
                label: dropingpoint.name,
            }));
            setDropingPointData(mappeddropingpoint);
        }
        if (fetchedDUnion) {
            const mappedUnion = fetchedDUnion.map((union: any) => ({
                value: union.unionId,
                label: union.name,
            }));
            setUnionData(mappedUnion);
        }
    }, [fetchedDropingPoint,fetchedcardCustomer,fetchedDUnion]);
    return (
        <>
            <FormikModelDialog
                width="65%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.PARTY}
                postRoute="CardCustomer/SaveCardCustomer"
                showAddAnother={true}
                isUpDateEntityDetails={data?.cardCustomerId > 0 ? true : false}
                isViewOnly ={isViewMode}


            >
                <div>
                    <div className="row">
                        <div className="col-2">
                            <InputField maxLength={6}
                                label="Code *"
                                name="customerCode" />
                        </div>
                        <div className="col-3">
                            <InputField maxLength={200}
                                label="Name *"
                                name="customerName" />
                        </div>
                        <div className="col-4">
                            <InputField maxLength={200}
                                label="Address"
                                name="address" />
                        </div>
                        <div className="col-3">
                            {/* <div className="row mt-1"> */}
                            <InputField
                                maxLength={10}
                                label="Pan Number"
                                name="panNumber"
                            />
                        </div>
                        <div className="col-3">
                            {/* <div className="row mt-1"> */}
                            <InputField
                                maxLength={10}
                                label="Mobile Number"
                                name="mobileNumber"
                            />

                            </div>
                        <div className="col-4">
                            <SelectField
                                label="Dropping Point"
                                name="droppingPointId"
                                options={dropingpointData}
                                unSelectValue={0}

                            />
                        </div>
                        <div className="col-4">
                            <SelectField
                                label="Union"
                                name="unionId"
                                options={unionData}
                                unSelectValue={0}

                            />
                        </div>





                        {/* </div> */}
                        <div className="col-3">
                            <InputField
                                maxLength={10}
                                label="Ration Card Number"
                                name="rationcardNumber"
                            />
                        </div>
                        <div className="col-3">
                            <InputField
                                maxLength={12}
                                label="Aadhar Card Number"
                                name="aadharNumber"
                            />
                        </div>
                        <div className="col-6 ">
                            <label>Customer Image</label>
                            <ImageUpload></ImageUpload>
                        </div>
                    </div>

                </div>

            </FormikModelDialog>
        </>
    );
};

export default CardCustomerEntry;
